/**
 * @generated SignedSource<<709b3b63054fce9df39664c7c77bf456>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksSpecialIndexContent$data = {
  readonly topics: ReadonlyArray<{
    readonly name: string;
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"hooksSeriesArticleSectionTagArticle">;
  readonly " $fragmentType": "hooksSpecialIndexContent";
};
export type hooksSpecialIndexContent$key = {
  readonly " $data"?: hooksSpecialIndexContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksSpecialIndexContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "hooksSpecialIndexContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "hooksSeriesArticleSectionTagArticle"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Topic",
      "kind": "LinkedField",
      "name": "topics",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "86f742adb6f317848ed9fe0f7c8d4392";

export default node;
